<template>
  <div class="hazmat-return-instructions">
    <div class="margin-bottom-s">
      <div class="h5 margin-bottom-xs">Required for a lithium battery</div>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <p class="margin-bottom-xs hazmat-battery-description" v-html="hazmatItemDescription"></p>
    </div>
    <div class="h5 margin-bottom-xs">
      {{ returnInstructionTitle }}
    </div>
    <ol class="margin-bottom-xs hazmat-instructions">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <li v-for="(instruction, k) in returnInstructionsComputed" :key="k" class="margin-left-xs" v-html="instruction"></li>
    </ol>
    <div>
      <p class="margin-bottom-xs hazmat-help">If the battery is damaged, contact {{ hazmatHelp }} for help with your return.</p>
      <p class="margin-bottom-xs">
        <strong aria-hidden="true">Note:</strong><span class="visibility-hidden">Note:</span> Failure to follow legal requirements for returns with a
        lithium battery could lead to an unsuccessful return.
      </p>
    </div>
  </div>
</template>
<script setup>
import { computed, ref } from 'vue';
import {
  brand,
  RETURN_METHOD_KEY_MAP,
  HAZMAT_INSTRUCTIONS,
  returnInstructions,
  hazmatReturnInstructions,
  fedExHazmatReturnInstructions,
} from 'config';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  isMkpOrder: {
    type: Boolean,
    default: false,
  },
  isFedexReturnMethod: {
    type: Boolean,
    default: false,
  },
});

const returnInstructionTitle = ref(returnInstructions.uopTitle);

const returnInstructionsComputed = computed(() => {
  if (brand === 'bcom') {
    return props.isFedexReturnMethod ? fedExHazmatReturnInstructions : hazmatReturnInstructions;
  }
  // For mcom hazmat we show ups return instructions as standard instructions
  return returnInstructions[RETURN_METHOD_KEY_MAP.ups];
});

const hazmatItemDescription = computed(() => {
  const hasContainedItem = props.items.some((item) => item.itemDetails.hazmatDescription === HAZMAT_INSTRUCTIONS.containedItem.key);
  const hasStandaloneItem = props.items.some((item) => item.itemDetails.hazmatDescription === HAZMAT_INSTRUCTIONS.standaloneItem.key);

  if (hasStandaloneItem || hasContainedItem) {
    return HAZMAT_INSTRUCTIONS.containedItem.text; // mixed, contained, or standalone
  }
  return HAZMAT_INSTRUCTIONS.packedItem.text; // packed
});

const hazmatHelp = computed(() => {
  if (brand === 'bcom') {
    return 'customer service at 1-800-777-0000';
  }
  return props.isMkpOrder ? 'the seller' : 'customer service';
});
</script>
